import { Box, Theme } from '@mui/material';
import React, { FC } from 'react';
import styled from 'styled-components';

const PostContainer: FC = ({ children }: any) => {
  return <Container>{children}</Container>;
};

const Container = styled(Box)`
  ${({ theme }: { theme: Theme }) => `
    flex: 1;
    padding: 5px;
    max-width: 550px;
    margin: 16px auto;
    ${theme.breakpoints.down('sm')} {
      padding: 0;
      padding-bottom: 80px;
    }
  `}
`;

export default PostContainer;
